<template>
	<div class="font-apercu-medium">
		<!-- Enquiry List Drawer -->
		<div class="enquiry-drawer-overlay" :class="{ 'visible': isOpen }" @click="closeEnquiryDrawer"></div>
		<div class="enquiry-drawer" :class="{ 'open': isOpen }">

			<div class="drawer-content">
				<!-- Left Column: List -->
				<div class="drawer-list-column">
					<div class="drawer-header">
						<h2 class="font-apercu-bold">Enquiry List ({{ enquiryList.length }})</h2>
					</div>
					<div v-if="loading" class="loading-indicator">Loading...</div>
					<transition-group v-else name="list" tag="div" class="enquiry-list-scroll-area">
						<div class="enquiry-item" v-for="item in enquiryList" :key="item.CartID || item.localId"
							:class="{ 'empty-customization': !item.isCustomise }">
							<div class="item-image">
								<img :src="item.image" alt="Product">
							</div>
							<div class="item-details"
								:class="{ 'empty-customization-item-details': !item.isCustomise }">
								<div class="item-top">
									<div class="item-top-left">
										<span class="item-category">{{ item.category }}</span>
										<span class="item-name">{{ item.name }}</span>
									</div>
									<button class="remove-btn" @click="removeEnquiryListItem(item)">Remove</button>
								</div>

								<div class="item-options">
									<label class="drawer-customise-checkbox">
										<input type="checkbox" v-model="item.isCustomise"
											@change="updateCustomizeStatus(item)" />
										<span class="checkmark"></span>
										<span class="label-text">Customise</span>
									</label>
									<div v-if="item.isCustomise" class="customization-input-container">
										<textarea v-model="item.customizationText"
											placeholder="Specify your customization here." class="customization-input"
											:class="{ 'has-text': item.customizationText && item.customizationText.length > 0 }"
											rows="2" @focus="handleInputFocus(item)"
											@blur="handleInputBlur(item)"></textarea>
										<div v-show="item.showSaveBtn" class="save-btn-container"
											@mousedown.prevent="saveCustomization(item)">
											<span class="save-btn">[Save]</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</transition-group>
				</div>

				<!-- Right Column: Form -->
				<div class="drawer-form-column" style="padding-right: 40rem;padding-top: 34rem;">
					<div class="drawer-header-icons">
						<div class="header-icon-group">
							<button class="icon-btn">
								<img src="@/assets/icon/search_black.png" alt="search" class="icon-img"
									@click="toggleSearch" /></button>
							<button class="icon-btn"><img src="@/assets/icon/user_black.png" alt="User" class="icon-img"
									@click="toggleUserInfo" /></button>
							<button class="icon-btn">
								<div class="bag-icon-wrapper">
									<img src="@/assets/icon/product_black.png" alt="Bag" class="icon-img"
										style="display:flex; align-items: center;justify-content: center;" />
									<span class="bag-count">{{ enquiryList.length }}</span>
								</div>
							</button>
						</div>
					</div>
					<div class="form-intro">
						<p v-if="!loggedInUser">To enquire about the selected pieces, complete the form below and we will be in touch shortly.</p>
						<div v-if="loggedInUser">
							<p>You're Logged in as</p>
							<p style="font-size: 28rem;padding-top: 5rem;">{{ loggedInUser.FirstName }}
								{{ loggedInUser.LastName }}</p>
						</div>

					</div>
					<form class="enquiry-form" @submit.prevent="sendEnquiryForm">
						<div class="form-group">
							<input type="text" placeholder="Name" class="drawer-input" v-model="formData.name"
								required />
						</div>
						<div class="form-group">
							<input type="email" placeholder="Email" class="drawer-input" v-model="formData.email"
								required />
						</div>
						<div class="form-group">
							<input type="text" placeholder="Phone (Optional)" class="drawer-input"
								v-model="formData.phone" />
						</div>
						<div class="form-group">
							<textarea placeholder="Additional Notes (Optional)" class="drawer-input textarea"
								v-model="formData.notes"></textarea>
						</div>
						<button type="submit" class="send-enquiry-btn font-apercu-medium" :disabled="submitting">
							{{ submitting ? 'Submitting...' : '[Send Enquiry]' }}
						</button>
					</form>
				</div>
			</div>
		</div>
		<!-- Remove Confirmation Modal -->
		<transition name="popup-scale">
			<div v-if="showRemovePopup" class="remove-popup-overlay">
				<div class="remove-popup">
					<h3>Are you sure you want to remove<br>{{ itemToRemove ? itemToRemove.name : 'this item' }}?</h3>
					<p>This will also delete your saved messages.</p>
					<div class="remove-actions">
						<button class="cancel-btn" @click="cancelRemove">I think I'll still keep it</button>
						<button class="confirm-btn" @click="confirmRemove">Go ahead, remove it</button>
					</div>
				</div>
			</div>
		</transition>
		<!-- Enquiry Sent Success Modal -->
		<transition name="enquiry-sent-anim">
			<div v-if="showEnquirySentPopup" class="enquiry-sent-popup-overlay" @click="closeEnquirySentPopup">
				<div class="enquiry-sent-popup">
					<h3>Enquiry Sent!</h3>
					<p class="product-count">{{ enquiryList.length }} Products</p>
					<p class="back-text">We will get back to you soon.</p>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	import {
		showMessage
	} from '@/config/message'
	import {
		getUser
	} from '@/config/auth'
	import {
		getCartItems,
		removeFromCart,
		updateCartItem,
		submitEnquiry
	} from '@/api/Enquiry'

	const LOCAL_CART_KEY = 'pending_enquiry_items'

	export default {
		name: 'Enquiry',
		props: {
			isOpen: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				loading: false,
				enquiryList: [],
				loggedInUser: null,
				formData: {
					name: '',
					email: '',
					phone: '',
					notes: ''
				},
				showRemovePopup: false,
				itemToRemove: null,
				showEnquirySentPopup: false,
				submitting: false, // 新增：提交中状态
			}
		},
		watch: {
			isOpen(val) {
				if (val) {
					this.loadCartItems();
				}
			}
		},
		mounted() {
			this.loadUser();
			if (this.isOpen) {
				this.loadCartItems();
			}
			// 监听登录成功事件，自动同步本地购物车到服务器
			this.$root.$on('login-success', this.syncLocalCartToServer)
		},
		beforeDestroy() {
			this.$root.$off('login-success', this.syncLocalCartToServer)
		},
		methods: {
			// 加载当前登录用户信息
			loadUser() {
				const user = getUser();
				if (user) {
					this.loggedInUser = user;
					this.formData.name = `${user.FirstName || ''} ${user.LastName || ''}`.trim() || user.Email;
					this.formData.email = user.Email || '';
					this.formData.phone = user.Phone || '';
				} else {
					this.loggedInUser = null;
					this.formData = {
						name: '',
						email: '',
						phone: '',
						notes: ''
					};
				}
			},

			// 获取本地存储的购物车项
			getLocalCart() {
				const raw = localStorage.getItem(LOCAL_CART_KEY)
				return raw ? JSON.parse(raw) : []
			},

			// 保存本地购物车
			saveLocalCart(items) {
				localStorage.setItem(LOCAL_CART_KEY, JSON.stringify(items))
			},

			// 加载购物车项（根据登录状态）
			async loadCartItems() {
				if (this.loggedInUser) {
					// 已登录：从后端加载
					this.loading = true;
					try {
						const items = await getCartItems(this.loggedInUser.UserID);
						this.enquiryList = items.map(item => ({
							CartID: item.CartID,
							ProductID: item.ProductID,
							image: item.ImageURL,
							category: item.CategoryName,
							name: item.ProductName,
							isCustomise: item.IsCustomized || false,
							customizationText: item.CustomisationText || '',
							showSaveBtn: false
						}));
					} catch (error) {
						console.error('Failed to load cart items:', error);
						showMessage('Failed to load enquiry list', 'error');
					} finally {
						this.loading = false;
					}
				} else {
					// 未登录：从本地存储加载
					const localItems = this.getLocalCart()
					this.enquiryList = localItems.map(item => ({
						localId: item.localId || Date.now() + Math.random(), // 唯一标识
						ProductID: item.ProductID,
						image: item.image,
						category: item.category,
						name: item.name,
						isCustomise: !!item.customizationText,
						customizationText: item.customizationText || '',
						showSaveBtn: false
					}))
				}
			},

			// 未登录时：添加/更新本地项（由ProductDetail调用，此处不需要）
			// 移除项
			async removeEnquiryListItem(item) {
				this.itemToRemove = item;
				this.showRemovePopup = true;
			},

			cancelRemove() {
				this.showRemovePopup = false;
				this.itemToRemove = null;
			},

			async confirmRemove() {
				if (!this.itemToRemove) return;
				if (this.loggedInUser) {
					// 已登录：调用后端删除
					try {
						await removeFromCart(this.itemToRemove.CartID, this.loggedInUser.UserID);
						this.enquiryList = this.enquiryList.filter(i => i.CartID !== this.itemToRemove.CartID);
						showMessage('Item removed', 'success');
					} catch (error) {
						console.error('Remove failed:', error);
						showMessage('Failed to remove item', 'error');
					}
				} else {
					// 未登录：删除本地存储项
					let localItems = this.getLocalCart()
					localItems = localItems.filter(i => i.localId !== this.itemToRemove.localId)
					this.saveLocalCart(localItems)
					this.enquiryList = this.enquiryList.filter(i => i.localId !== this.itemToRemove.localId)
					showMessage('Item removed', 'success');
				}
				this.showRemovePopup = false;
				this.itemToRemove = null;
			},

			// 更新定制状态（仅登录时调用后端，未登录操作本地）
			async updateCustomizeStatus(item) {
				if (!item.isCustomise) {
					item.customizationText = '';
				}
				await this.saveCustomization(item);
			},

			async saveCustomization(item) {
				if (this.loggedInUser) {
					try {
						await updateCartItem({
							CartID: item.CartID,
							UserID: this.loggedInUser.UserID,
							CustomisationText: item.customizationText || ''
						});
						item.showSaveBtn = false;
						showMessage('Customization saved', 'success');
					} catch (error) {
						console.error('Save failed:', error);
						showMessage('Failed to save customization', 'error');
					}
				} else {
					// 未登录：更新本地存储
					let localItems = this.getLocalCart()
					const target = localItems.find(i => i.localId === item.localId)
					if (target) {
						target.customizationText = item.customizationText
						this.saveLocalCart(localItems)
					}
					item.showSaveBtn = false;
					showMessage('Customization saved locally', 'success');
				}
			},

			handleInputFocus(item) {
				item.showSaveBtn = true;
			},

			handleInputBlur(item) {
				setTimeout(() => {
					item.showSaveBtn = false;
				}, 200);
			},

			// 同步本地购物车到服务器（登录后调用）
			async syncLocalCartToServer() {
				const localItems = this.getLocalCart()
				if (localItems.length === 0) return

				if (!this.loggedInUser) return

				let successCount = 0
				for (const item of localItems) {
					try {
						// 调用添加购物车接口（假设后端有此接口，使用 addToCart）
						// 这里需要引入 addToCart API。如果没有，可以调用 updateCartItem 或新建。
						// 注意：ProductDetail.vue 中已使用 addToCart，这里应当使用相同的 API
						const {
							addToCart
						} = await import('@/api/Enquiry')
						const model = {
							ProductID: item.ProductID,
							UserID: this.loggedInUser.UserID,
							CustomisationText: item.customizationText || ''
						}
						const response = await addToCart(model)
						if (response.retCode === 1) {
							successCount++
						}
					} catch (err) {
						console.error('Sync item failed', item, err)
					}
				}
				if (successCount > 0) {
					showMessage(`Synced ${successCount} item(s) to your enquiry list`, 'success')
				}
				// 清空本地存储
				this.saveLocalCart([])
				// 重新加载列表
				await this.loadCartItems()
			},

			// 提交询价
			// async sendEnquiryForm() {
			// 	if (!this.loggedInUser) {
			// 		this.closeEnquiryDrawer();
			// 		showMessage('Please log in first', 'error');
			// 		this.$emit('open-login');
			// 		return;
			// 	}
			// 	if (!this.formData.name || !this.formData.email) {
			// 		this.closeEnquiryDrawer();
			// 		showMessage('Name and email are required', 'error');
			// 		return;
			// 	}
			// 	if (this.enquiryList.length === 0) {
			// 		this.closeEnquiryDrawer();
			// 		showMessage('No products in enquiry list', 'error');
			// 		return;
			// 	}

			// 	const products = this.enquiryList.map(item => ({
			// 		ProductID: item.ProductID,
			// 		Quantity: 1,
			// 		CustomisationText: item.isCustomise ? item.customizationText : ''
			// 	}));

			// 	try {
			// 		const model = {
			// 			UserID: this.loggedInUser.UserID,
			// 			Name: this.formData.name,
			// 			Email: this.formData.email,
			// 			Phone: this.formData.phone || '',
			// 			AdditionalNotes: this.formData.notes || '',
			// 			Products: products
			// 		};
			// 		await submitEnquiry(model);
			// 		this.showEnquirySentPopup = true;
			// 	} catch (error) {
			// 		console.error('Submit enquiry failed:', error);
			// 		this.closeEnquiryDrawer();
			// 		showMessage('Failed to submit enquiry', 'error');
			// 	}
			// },
			async sendEnquiryForm() {
				// 防止重复提交
				if (this.submitting) return;

				// 基础验证
				if (!this.formData.name || !this.formData.email) {
					showMessage('Name and email are required', 'error');
					return;
				}
				if (this.enquiryList.length === 0) {
					showMessage('No products in enquiry list', 'error');
					this.closeEnquiryDrawer();
					return;
				}

				this.submitting = true; // 开始提交，显示等待提示

				const products = this.enquiryList.map(item => ({
					ProductID: item.ProductID,
					Quantity: 1,
					CustomisationText: item.isCustomise ? item.customizationText : ''
				}));

				const model = {
					UserID: this.loggedInUser ? this.loggedInUser.UserID : 0,
					Name: this.formData.name,
					Email: this.formData.email,
					Phone: this.formData.phone || '',
					AdditionalNotes: this.formData.notes || '',
					Products: products
				};

				try {
					await submitEnquiry(model);
					this.showEnquirySentPopup = true;

					// 清空购物车
					if (this.loggedInUser) {
						await this.loadCartItems();
					} else {
						this.saveLocalCart([]);
						this.enquiryList = [];
					}
				} catch (error) {
					console.error('Submit enquiry failed:', error);
					showMessage('Failed to submit enquiry. Please try again.', 'error');
				} finally {
					this.submitting = false; // 无论成功或失败，结束提交状态
				}
			},

			// closeEnquirySentPopup() {
			// 	this.showEnquirySentPopup = false;
			// 	setTimeout(() => {
			// 		this.closeEnquiryDrawer();
			// 	}, 300);
			// },
			closeEnquirySentPopup() {
				this.showEnquirySentPopup = false;
				// 弹窗关闭后，再关闭整个询价抽屉
				this.closeEnquiryDrawer();
			},

			closeEnquiryDrawer() {
				this.$emit('close')
			},

			toggleSearch() {
				this.$emit('toggle-search')
			},

			toggleUserInfo() {
				this.$emit('toggle-user-info')
			}
		}
	}
</script>

<style scoped>
	.icon-btn {
		background: none;
		border: none;
		cursor: pointer;
		color: inherit;
		padding: 5rem;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: opacity 0.3s;

	}

	.icon-img {
		width: 22rem;
		height: 22rem;
	}

	/* Enquiry List Drawer */
	.enquiry-drawer-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 3000;
		opacity: 0;
		visibility: hidden;
		transition: opacity 0.5s ease;
	}

	.enquiry-drawer-overlay.visible {
		opacity: 1;
		visibility: visible;
	}

	.enquiry-drawer {
		position: fixed;
		z-index: 3001;
		top: 0;
		right: 0;
		width: 70%;
		/* Adjust based on design, seemingly wide */
		max-width: 1000rem;
		height: 100%;
		background-color: #fff;
		transform: translateX(100%);
		transition: transform 0.8s cubic-bezier(0.19, 1, 0.22, 1);
		/* Slower, smooth ease-out */
		display: flex;
		flex-direction: column;
		border-left: 1rem solid #000;
	}

	.enquiry-drawer.open {
		transform: translateX(0);
	}

	.drawer-header {
		padding: 0rem 60rem 43rem 60rem;
		text-align: center;
		border-bottom: 1rem solid #000;
	}

	.drawer-header h2 {
		font-size: 24rem;
		font-weight: 600;
		margin: 0;
	}

	.drawer-content {
		display: flex;
		flex: 1;
		overflow-y: auto;
	}

	.drawer-list-column {
		width: 593rem;
		height: 100%;
		border-right: 1rem solid #000;
		display: flex;
		flex-direction: column;
		/* Take full height of parent */
		overflow: hidden;
		/* Prevent container itself from scrolling */
		padding-top: 184rem;
	}

	.enquiry-list-scroll-area {
		flex: 1;
		height: 560rem;
		/* Take remaining height */
		overflow-y: auto;
		overflow-x: hidden;
		position: relative;

		/* Enable vertical scroll */
		/* Hide scrollbar for Chrome/Safari/Opera */
		&::-webkit-scrollbar {
			display: none;
		}

		/* Hide scrollbar for IE, Edge and Firefox */
		-ms-overflow-style: none;
		/* IE and Edge */
		scrollbar-width: none;
		/* Firefox */
	}

	/* Enquiry Item */
	.enquiry-item {
		display: flex;
		padding: 0;
		border-bottom: 1rem solid #000;
		position: relative;
		background-color: #fff;
		max-height: 250rem;
		overflow: hidden;
		/* 防止内容溢出 */
		transition: max-height 0.5s ease;
		/* 添加高度过渡动画 */
		/* Ensure solid background for animations */
	}

	/* 列表移除动画 */
	/* 
   注意：必须将动画类放在 .enquiry-item 之后定义，
   否则 transition 属性会被 .enquiry-item 的定义覆盖，导致 list-move 失效 
*/
	.list-leave-active {
		/* 离开动画激活状态：定义过渡属性 */
		/* 只保留离开动画，不影响其他元素的布局移动（通过 absolute 实现） */
		transition: transform 0.5s ease, opacity 0.5s ease !important;
		position: absolute;
		left: 0;
		right: 0;
		z-index: 10;
		background-color: #fff;
	}

	.list-leave-to {
		/* 离开动画结束状态 */
		/* 向右平移出视口 */
		transform: translateX(100%);
		/* 透明度变为0 */
		opacity: 0;
	}

	.list-move {
		/* 其他列表项移动填补空位的过渡效果 */
		/* 使用 !important 确保覆盖 .enquiry-item 的 transition 设置 */
		transition: transform 0.5s ease !important;
	}

	.drawer-form-column {
		width: 50%;
		max-width: 445rem;
		padding: 20rem 37rem 20rem 43rem;
		display: flex;
		flex-direction: column;
	}


	.drawer-header-icons {
		display: flex;
		justify-content: flex-end;
		/* Space between icons and intro text */
		padding-top: 14rem;
		/* Align with list header */
	}

	.header-icon-group {
		display: flex;
		align-items: center;
		gap: 23rem;
	}

	.header-icon-group .icon {
		width: 20rem;
		height: 20rem;
		cursor: pointer;
	}

	.bag-icon-wrapper {
		position: relative;
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.bag-count {
		position: absolute;
		top: 60%;
		left: 50%;
		transform: translate(-50%, -50%);
		/* Center in bag */
		font-size: 11rem;
		font-weight: 600;
		color: #000;
	}

	.enquiry-item.empty-customization {
		max-height: 213rem;
		/* 改为 max-height 以支持过渡动画 */
	}

	.item-image {
		width: 200rem;
		margin-right: 20rem;
		background-color: #f5f5f5;
		border-right: 1rem solid #000;
	}

	.item-image img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	.item-details {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding: 36rem 0;
		padding-left: 20rem;
		padding-right: 24rem;
	}

	.item-category {
		font-size: 16rem;
		color: rgba(0, 0, 0, 0.3);
		margin-bottom: 4rem;
		font-weight: 500;
	}

	.item-name {
		font-size: 20rem;
		font-weight: 500;
		margin-bottom: 20rem;
	}

	.item-options {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding-right: 10rem;
	}

	.drawer-customise-checkbox {
		display: flex;
		align-items: center;
		cursor: pointer;
		font-size: 16rem;
		font-weight: 500;
	}

	.customization-input-container {
		width: 100%;
		margin-top: 10rem;
	}

	.customization-input {
		width: 100%;
		border: none;
		/* border-bottom: 1rem solid #000; */
		font-size: 14rem;
		outline: none;
		color: #000;
		resize: none;
		overflow-y: auto;
		scrollbar-width: thin;
		background: transparent;
		margin-top: 42rem;
		font-family: 'Apercu-Medium', sans-serif;
	}

	.customization-input::-webkit-scrollbar {
		width: 1rem;
		/* Chrome/Safari */
		background: transparent;
	}

	textarea::-webkit-scrollbar-button {
		display: none;
	}

	.customization-input::-webkit-scrollbar-thumb {
		background: #000;
	}

	.customization-input::-webkit-scrollbar-button,
	.customization-input::-webkit-scrollbar-corner {
		display: none;
	}

	.customization-input.has-text {
		border-bottom: none;
		color: #999;
	}

	.customization-input::placeholder {
		color: #ccc;
	}

	.save-btn-container {
		display: flex;
		justify-content: flex-end;
		margin-top: 5rem;
	}

	.save-btn {
		font-size: 13rem;
		font-weight: 600;
		cursor: pointer;
	}

	.drawer-customise-checkbox input {
		display: none;
	}

	.drawer-customise-checkbox .checkmark {
		width: 14rem;
		height: 14rem;
		border: 1rem solid #000;
		border-radius: 2rem;
		margin-right: 10rem;
		position: relative;
		transition: background-color 0.2s;
		box-sizing: border-box;
		display: inline-block;
	}

	.drawer-customise-checkbox input:checked+.checkmark {
		background-color: transparent;
	}

	.drawer-customise-checkbox input:checked+.checkmark:after {
		content: "";
		position: absolute;
		display: block;
		left: 50%;
		top: 50%;
		width: 10rem;
		height: 10rem;
		background-color: #000;
		transform: translate(-50%, -50%);
		border: none;
	}

	.specified-text {
		font-size: 12rem;
		color: #ccc;
		margin-left: auto;
	}

	/* Item Top */
	.item-top {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		padding-right: 10rem;
	}

	.item-top-left {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	.remove-btn {
		background: none;
		border: none;
		text-decoration: underline;
		font-size: 16rem;
		cursor: pointer;
		padding: 0;
		font-family: 'Apercu-Medium';
		font-weight: 500;
	}

	/* Form */
	.form-intro {
		padding-top: 197rem;
		margin-bottom: 96rem;
		text-align: center;
	}

	.form-intro p {
		font-size: 20rem;
		max-width: 300rem;
		margin: 0 auto;
		font-weight: 600;
		padding: 0 34rem;
	}

	.enquiry-form {
		width: 100%;
		max-width: 350rem;
		margin: 0 auto;
	}

	.form-group {
		margin-bottom: 8rem;
		height: 30rem;
		font-family: 'BespokeSerif-Italic';
		font-weight: 400;
	}

	.drawer-input {
		width: 100%;
		border: none;
		border-bottom: 2rem solid #000;
		padding: 10rem 0;
		font-size: 14rem;
		outline: none;
		/* Match design style */
		font-style: italic;
		color: #000;
		font-family: 'Apercu-Medium', sans-serif;
	}

	.drawer-input::placeholder {
		font-family: 'BespokeSerif-Italic' !important;
	}

	.drawer-input.textarea {
		resize: none;
		height: 40rem;
	}

	.send-enquiry-btn {
		background: none;
		border: none;
		font-size: 20rem;
		font-weight: 500;
		cursor: pointer;
		display: block;
		margin-top: 87rem;
		margin-left: auto;
		margin-right: auto;
		margin-bottom: 164rem;
	}

	/* Remove Confirmation Popup */
	.remove-popup-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		/* Semi-transparent background */
		z-index: 4000;
		/* Higher than enquiry drawer */
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.remove-popup {
		background-color: #fff;
		padding: 61rem 10rem;
		width: 437rem;
		height: 247rem;
		text-align: center;
		box-shadow: 0 4rem 20rem rgba(0, 0, 0, 0.1);
		border: 2rem solid #000;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.remove-popup h3 {
		font-size: 20rem;
		font-weight: 500;
		margin-bottom: 15rem;
		line-height: 1.4;
	}

	.remove-popup p {
		font-size: 14rem;
		color: rgba(0, 0, 0, 0.3);
		margin-bottom: 30rem;
	}

	.remove-actions {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0;
		width: 70%;
	}

	.cancel-btn,
	.confirm-btn {
		background: none;
		border: none;
		cursor: pointer;
		font-size: 14rem;
		font-weight: 500;
	}

	.cancel-btn {
		color: #000;
	}

	.confirm-btn {
		color: rgba(0, 0, 0, 0.3);
		/* Light grey for "Duh, just remove it" */
	}

	/* Popup Transition */
	.popup-scale-enter-active,
	.popup-scale-leave-active {
		transition: opacity 0.3s ease;
	}

	.popup-scale-enter,
	.popup-scale-leave-to {
		opacity: 0;
	}

	.popup-scale-enter-active .remove-popup,
	.popup-scale-leave-active .remove-popup {
		transition: transform 0.3s ease;
	}

	.popup-scale-enter .remove-popup,
	.popup-scale-leave-to .remove-popup {
		transform: scale(0);
	}

	/* Enquiry Sent Success Popup */
	.enquiry-sent-popup-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		/* Dimmed background */
		z-index: 5000;
		/* Highest z-index */
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.enquiry-sent-popup {
		text-align: center;
		width: 437rem;
		height: 247rem;
		/* Match remove-popup width */
		background-color: #fff;
		padding: 70rem 0;
		/* Match remove-popup padding */
		box-shadow: 0 4rem 20rem rgba(0, 0, 0, 0.1);
		border: 1rem solid #000;
		/* Match remove-popup shadow */
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.enquiry-sent-popup h3 {
		font-size: 20rem;
		/* Match remove-popup h3 */
		font-weight: 500;
		/* Match remove-popup h3 */
		margin-bottom: 15rem;
		/* Match remove-popup h3 */
		line-height: 1.4;
		/* Match remove-popup h3 */
		color: #000;
	}

	.enquiry-sent-popup .product-count {
		font-size: 14rem;
		font-weight: 600;
		margin-bottom: 71rem;
	}

	.enquiry-sent-popup .back-text {
		font-size: 14rem;
		color: rgba(0, 0, 0, 0.3);
		color: rgba(0, 0, 0, 0.3);
	}

	/* Enquiry Sent Animation */
	.enquiry-sent-anim-enter-active,
	.enquiry-sent-anim-leave-active {
		transition: opacity 0.3s;
	}

	.enquiry-sent-anim-enter-active .enquiry-sent-popup,
	.enquiry-sent-anim-leave-active .enquiry-sent-popup {
		transition: transform 0.3s ease-out;
	}

	.enquiry-sent-anim-enter,
	.enquiry-sent-anim-leave-to {
		opacity: 0;
	}

	.enquiry-sent-anim-enter .enquiry-sent-popup,
	.enquiry-sent-anim-leave-to .enquiry-sent-popup {
		transform: scale(0);
	}


	.empty-customization-item-details {
		justify-content: space-between;
	}

	.send-enquiry-btn:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	/* Responsive */
	@media (max-width: 768px) {
		.enquiry-drawer {
			width: 90%;
		}

		.drawer-content {
			flex-direction: column;
		}

		.drawer-list-column,
		.drawer-form-column {
			width: 100%;
			border-right: none;
		}

		.drawer-list-column {
			border-bottom: 1rem solid #000;
			border-right: 1rem solid #000;
			height: 50%;
		}

		.drawer-form-column {
			height: 50%;
			overflow-y: auto;
		}
	}
</style>